export function ChorusIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 150 150"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="chorus-icon"
    >
      <path
        fill="#3c82e9"
        d="M74.96,10.25C34.24,9.79,2.27,48.74,10.67,88.59c11.64,57.12,86.17,71.94,118.78,23.63,29.03-43.26-2.4-102.06-54.5-101.96ZM39.52,84.19c-.11,6.69-10.07,6.7-10.19,0,0,0,0-16.78,0-16.78-.15-4.39,5.69-6.82,8.7-3.6,.96,.96,1.49,2.25,1.49,3.6v16.78Zm16.58,17.16c-.11,6.68-10.08,6.71-10.19,0,0,0,0-51.09,0-51.09,.11-6.68,10.08-6.71,10.19,0,0,0,0,51.09,0,51.09Zm16.57,14.93c-.11,6.67-10.07,6.72-10.19,0,0,0,0-80.95,0-80.95,.1-6.67,10.07-6.72,10.19,0,0,0,0,80.95,0,80.95Zm16.58-15.55c-.11,6.68-10.07,6.71-10.19,0,0,0,0-49.86,0-49.86-.15-4.39,5.69-6.83,8.7-3.6,.96,.95,1.49,2.25,1.49,3.6v49.86Zm16.58,7.74c-.11,6.67-10.08,6.71-10.19,0,0,0,0-65.34,0-65.34-.15-4.39,5.7-6.83,8.7-3.6,.95,.94,1.5,2.27,1.49,3.6,0,0,0,65.34,0,65.34Zm16.57-24.96c-.11,6.69-10.07,6.7-10.19,0,0,0,0-15.41,0-15.41,.11-6.69,10.07-6.7,10.19,0,0,0,0,15.41,0,15.41Z"
      />
    </svg>
  );
}
